import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Página Não Encontrada</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="flex items-center justify-center min-h-screen bg-rn-bg px-4">
        <Card className="w-full max-w-md p-8 text-center" hover={false}>
          <p className="text-4xl font-semibold text-rn-orange-text mb-3">404</p>
          <h1 className="text-2xl font-semibold text-rn-navy mb-3">
            Página não encontrada
          </h1>
          <p className="text-rn-text-soft mb-8">
            Desculpe, a página que você está procurando não existe.
          </p>
          <Link to="/">
            <Button className="w-full">Voltar para a Home</Button>
          </Link>
        </Card>
      </div>
    </>
  );
};

export default NotFoundPage;
